module.exports = __webpack_public_path__ + "img/at.e8baec59.svg";